import React from "react";
import { useTheme } from "next-themes";
import { Link } from "react-router-dom";

const Logo = () => {
  const { theme, resolvedTheme } = useTheme();
  
  // Determine which theme to use - resolvedTheme handles 'system' theme properly
  const currentTheme = resolvedTheme || theme;
  const isDark = currentTheme === "dark";
  
  const logoSrc = isDark 
    ? "/female-partner-calculator-logo-dark.png"
    : "/female-partner-calculator-logo-light.png";

  return (
    <Link 
      to="/" 
      className="flex items-center hover:opacity-80 transition-opacity"
      aria-label="Female Partner Calculator Home"
    >
      <img
        src={logoSrc}
        alt="Female Partner Calculator"
        className="h-8 md:h-10 w-auto"
        loading="eager"
      />
    </Link>
  );
};

export default Logo;